import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { fetchEntity } from 'modules/entity/actions';
import { closeInterventionUpdateModal } from 'modules/works/actions';

import * as actionTypes from '../../actionTypes';

/**
 * @typedef {boolean} IsInterventionUpdateModalOpenState
 */

/** @type {IsInterventionUpdateModalOpenState} */
const initialState = false;

const open = () => true;
const reset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.OPEN_INTERVENTION_UPDATE_MODAL, open)
    .addMatcher(isAnyOf(fetchEntity.match, closeInterventionUpdateModal.match), reset);
});
